import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 pt-16 flex items-center justify-center px-4">
        <div className="flex flex-col items-center justify-center text-center py-20">
          <h1 className="text-7xl md:text-9xl font-black text-primary-100 select-none">404</h1>
          <p className="text-xl md:text-2xl font-bold text-foreground-950 mt-2">
            内容走丢了
          </p>
          <p className="text-sm text-foreground-500 mt-2 mb-6">
            你访问的页面不存在或已被移除，去首页看看更多精彩短视频吧
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-2 h-11 px-6 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/search"
              className="flex items-center gap-2 h-11 px-6 rounded-full border border-background-200 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line"></i>
              去搜索视频
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}